import { render, staticRenderFns } from "./IconAdd.vue?vue&type=template&id=3566bc3d"
import script from "./IconAdd.vue?vue&type=script&lang=ts"
export * from "./IconAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports